/// <amd-module name="Core/Medius.Core.Web/Scripts/AdminPages/PaymentTerm/extensionRegistration"/>
import * as ExtensionPointsRegistry from "Core/Medius.Core.Web/Scripts/AdminPages/extensionPointsRegistry";
import { ExtensionRightSide } from "./extensionRightSide";

export function register() {
    ExtensionPointsRegistry.register("Medius.Enterprise.Entities.PaymentTerm", {
        rightSide: () => new ExtensionRightSide()
    });
}
